define(['angular', 'ng-file-upload'], function (angular) {
    'use strict';

    return (
        angular
            .module('fileUploadService', ['ngFileUpload'])
            // Global service for error handling
            .factory('FileUpload', [
                '$q',
                '$rootScope',
                'Upload',
                function ($q, $rootScope, Upload) {
                    function checkFile(file) {
                        if (file.size > 6000000) {
                            //6mb This should match mindbox_user_avatar/maxSize in config.yml
                            return "Whoa! That file is too big. <a href='https://compressor.io/compress' target='_blank'>Try using this website</a> to shrink down your file size.";
                        }
                        return true;
                    }

                    function checkImage(file) {
                        if (
                            file.type != 'image/jpeg' &&
                            file.type != 'image/png' &&
                            file.type != 'image/gif'
                        ) {
                            return 'The image you tried to upload is the wrong file type.  Please upload a JPG, PNG, or GIF file.';
                        }
                        return true;
                    }

                    function checkAudio(file) {
                        if (
                            file.type != 'audio/mpeg' &&
                            file.type != 'audio/mp3' &&
                            file.type != 'audio/mp4' &&
                            file.type != 'audio/vnd.wav' &&
                            file.type != 'audio/x-wav' &&
                            file.type != 'audio/wav'
                        ) {
                            return 'The file you tried to upload is the wrong type.  Please upload a MP3, MP4, or WAV file.';
                        }
                        return true;
                    }

                    return {
                        /**
                         * General file upload handling
                         *
                         * Returns an object with several callbacks.  For example:
                         * .progress(function (e) {
                         *      progressTracker = parseInt(100.0 * e.loaded / e.total);
                         * })
                         * .success(function (data) {
                         *      $scope.settings = Settings.getSettings(true);
                         * })
                         * .error(function (response) {
                         *      errorTracker = response[0].message;
                         * })
                         * .then(function () {
                         *      progressTracker = 0;
                         * })
                         */
                        upload: function (
                            file,
                            ownerId,
                            ownerClass,
                            imageFilter, // Specify which Imagine filter to use for the url in the response
                            property // Specify a custom property (other than "avatar") in which the image is stored
                        ) {
                            var errors = [];
                            var error = checkFile(file);
                            if (error !== true) {
                                errors.push(error);
                            }

                            if (errors.length > 0) {
                                var deferred = $q.defer();
                                deferred.reject(errors);
                                return deferred.promise;
                            }

                            var params = {
                                owner: ownerId,
                            };
                            if (ownerClass) {
                                params.ownerClass = ownerClass;
                            }
                            if (property) {
                                params.ownerProperty = property;
                            }
                            return Upload.upload({
                                url: $rootScope.Routing.generate(
                                    'change_avatar',
                                    params
                                ),
                                method: 'POST',
                                data: {
                                    image_filter: imageFilter,
                                },
                                file: file,
                                transformResponse: function (data) {
                                    return data;
                                }, // Make sure Angular doesn't try to parse the response as JSON.
                            });
                        },
                        /**
                         * Uploader with additional image type checks
                         */
                        uploadImage: function (
                            file,
                            ownerId,
                            ownerClass,
                            imageFilter, // Specify which Imagine filter to use for the url in the response
                            property // Specify a custom property (other than "avatar") in which the image is stored
                        ) {
                            var errors = [];
                            var error = checkImage(file);
                            if (error !== true) {
                                errors.push(error);
                            }
                            error = checkFile(file);
                            if (error !== true) {
                                errors.push(error);
                            }

                            if (errors.length > 0) {
                                var deferred = $q.defer();
                                deferred.reject(errors);
                                return deferred.promise;
                            }

                            return this.upload(
                                file,
                                ownerId,
                                ownerClass,
                                imageFilter,
                                property
                            );
                        },
                        uploadLeads: function (file) {
                            return Upload.upload({
                                url: $rootScope.Routing.generate(
                                    'import_leads'
                                ),
                                method: 'POST',
                                file: file,
                            });
                        },
                    };
                },
            ])
    );
});
